import { Component, Vue, Emit, Provide } from 'vue-property-decorator';
import ViewPage from '@/mixins/Views';
import VueRouter from 'vue-router';
// @ is an alias to /src
import store from '@/store';
import PageHeader from '@/components/page/PageHeader.vue';
import PageSearchword from '@/components/page/PageSearchword.vue';

Component.registerHooks([
  'beforeRouteEnter',
  'beforeRouteUpdate',
  'beforeRouteLeave',
]);

@Component({
  components: {
    PageHeader,
    PageSearchword,
  },
})
export default class Search extends Vue {
  private name = 'search';
  get sideNaviDate(): boolean {
    if (
      this.$route.params.area === 'taiwan' ||
      this.$route.params.area === 'shizuoka'
    ) {
      return false;
    } else {
      return true;
    }
  }
  @Emit()
  private hotelNoResult() {
    if (store.getters['search/hits'] === 0) {
      window.gtag('event', 'hotelSeach', { searchNoResult: this.$route.params.q });
    }
  }
  private async beforeRouteEnter(to: any, from: VueRouter, next: any) {
    let result: ApiHotels | null = null;
    try {
      store.commit('search/resetData');
      if(store.getters['auth/lang'] === 'en') {
        to.params.lang = 'en';
      } else {
        to.params.lang = 'ja';
      }
      result = await store.dispatch('search/getEntry', {
        name: to.name,
        search: to.params,
      });
      let breadcrumbPath: BreadcrumbPath[] = [];
      if (store.getters['auth/lang'] === 'en') {
        breadcrumbPath = [
          {
            label: 'home',
            url: '/en',
          },
          {
            label: store.getters['search/word'],
            url: to.path,
          },
        ];
      } else {
        breadcrumbPath = [
          {
            label: 'ホーム',
            url: '/',
          },
          {
            label: store.getters['search/word'],
            url: to.path,
          },
        ];
      }
      store.commit('breadcrumb/setPath', breadcrumbPath);
    } finally {
      store.commit('search/setLoaded', true);
      store.commit('loaded', true);
      next((vm: any) => {
        if (result && result.hits === 0) {
          vm.hotelNoResult();
        }
      });
    }
  }
  private async beforeRouteUpdate(to: any, from: VueRouter, next: any) {
    let result: ApiHotels | null = null;
    try {
        store.commit('search/resetData');
        if(store.getters['auth/lang'] === 'en') {
          to.params.lang = 'en';
        } else {
          to.params.lang = 'ja';
        }
        result = await store.dispatch('search/getEntry', {
          name: to.name,
          search: to.params,
        });
        let breadcrumbPath: BreadcrumbPath[] = [];
        if (store.getters['auth/lang'] === 'en') {
          breadcrumbPath = [
            {
              label: 'home',
              url: '/en',
            },
            {
              label: store.getters['search/word'],
              url: to.path,
            },
          ];
        } else {
          breadcrumbPath = [
            {
              label: 'ホーム',
              url: '/',
            },
            {
              label: store.getters['search/word'],
              url: to.path,
            },
          ];
        }
        store.commit('breadcrumb/setPath', breadcrumbPath);
    } finally {
      store.commit('search/setLoaded', true);
      store.commit('loaded', true);
      next();
      if (result && result.hits === 0) {
        this.hotelNoResult();
      }      
    }
  }
  mounted() {
    const $query: any = this.$route.query;
    if (typeof $query.today_calender_area !== 'undefined') {
      store.commit('searchmodal/open', 'ModalTodayLowestPrice');
    }
    if (typeof $query.hotel_calender_area !== 'undefined') {
      store.commit('searchmodal/open', 'ModalSearchDate');
    }
  }
}
